<script>
export default {
  name: 'PhoneInput',
  props: {
    modelValue: String,
    invalid: { type: Boolean, default: false },
    placeholder: {
      type: String,
      default: 'Typ hier uw telefoonnummer'
    }
  },
  emits: ['update:modelValue']
}
</script>

<template>
  <div class="phone-holder">
    <h3 for="phone">Telefoonnummer</h3>
    <input
      id="phone"
      type="text"
      class="grey-field"
      :placeholder="placeholder"
      :value="modelValue"
      :class="{ invalid: invalid }"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<style scoped lang="scss">
.phone-holder {
  display: flex;
  align-items: center;

  h3 {
    padding-right: 5px;
  }

  input {
    width: 210px;
  }
}
</style>
